export const SET_LEAD_APPEND_ID: string = "SET_LEAD_APPEND_ID";
